// extracted by mini-css-extract-plugin
export default {"wrapper":"TopRatedProducts_wrapper__JDo+0"};